// The text size (decision 071, F441): the reader's choice among three
// scales (standard, larger at 115%, largest at 130%), kept on this device
// (the browser's storage, never the platform: a display preference) and
// applied as the root font size before the first paint (main.tsx), so
// every measure in rem follows (WCAG 1.4.4: a larger text without loss of
// content or function; inside the companion's window there is no zoom
// shortcut, so this choice is the way).

export type TextSize = "standard" | "larger" | "largest";

export const TEXT_SIZES: { value: TextSize; label: string; scale: number }[] = [
  { value: "standard", label: "Standard", scale: 1 },
  { value: "larger", label: "Larger", scale: 1.15 },
  { value: "largest", label: "Largest", scale: 1.3 },
];

const KEY = "sharifly.text-size";
const BASE_PX = 14;

export function readTextSize(): TextSize {
  try {
    const v = window.localStorage.getItem(KEY);
    return TEXT_SIZES.some((t) => t.value === v) ? (v as TextSize) : "standard";
  } catch {
    return "standard";
  }
}

/** Applies a size to the document and keeps it for the next visit. */
export function applyTextSize(size: TextSize): void {
  const scale = TEXT_SIZES.find((t) => t.value === size)?.scale ?? 1;
  document.documentElement.style.fontSize = `${Math.round(BASE_PX * scale * 10) / 10}px`;
  try {
    window.localStorage.setItem(KEY, size);
  } catch {
    // A private window or blocked storage: the size holds for this visit.
  }
}
